//angular
import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatIconRegistry } from '@angular/material/icon';
import { Router } from '@angular/router';
//app
import { AppAnimations } from '../../../../../../_shared/animations';
import { collectionOfRatePlanOptions, DunningCycleActions } from 'src/app/app.data';
import { RestResponse } from '../../../../../../_shared/models';
import { MetaService } from 'src/app/_core/services/meta.service';
import { DropDown } from 'src/app/_shared/interfaces/dropdown.interface';
import { SettingsService } from '../../../_services/api/settings.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
import { UtilsService } from 'src/app/_core/services/utils.service';

@Component({
  animations: [AppAnimations],
  host: { '[@smoothAppearance]': '', '[@slideInRightAnimation]': '' },
  selector: 'app-automatic-payments-config',
  templateUrl: './automatic-payments-config.component.html'
})

export class DunningAutomaticConfigComponent implements OnInit, OnDestroy {
  collectionOfCounters: Array<number> = [];
  collectionOfRatePlanOptions: Array<DropDown> = collectionOfRatePlanOptions;
  dunningCycle: any;
  form: FormGroup;
  formSubmitted: boolean = false;
  isFormReady: boolean = false;
  selectedRatePlanOption: string = 'Expire rate plan';
  statusLoader: number = 1;
  private subs = new Unsubscriber();

  constructor(
    private _iconRegistry: MatIconRegistry,
    private _fb: FormBuilder,
    private _meta: MetaService,
    private _router: Router,
    private _sanitizer: DomSanitizer,
    private settingsService: SettingsService,
    private utils: UtilsService,
  ) {
    this._iconRegistry.addSvgIcon('ico-back', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-back-03.svg'));
  }

  setUpForm() {
    this.form = this._fb.group({
      dunningCycle: new FormArray([]),
      dunningCycleAction: [DunningCycleActions.stop_cancel, [Validators.required,]], // 'stop_cancel' || 'stop' || 'retry'
    });

    this.dunningCycle = <FormArray>this.form.controls['dunningCycle'];
  }

  fillDunningCycle(collection) {
    collection.forEach((element, i) => {
      this.newNotificationEmail(i, element);
    })
  }

  getDunningConfig() {
    this.subs.addSub = this.settingsService.getDunningConfiguration('dunningConfigAuto').subscribe(
      (res: any) => {
        let config = res.data.value ? res.data.value : '';

        if (config) {
          this.form.controls['dunningCycleAction'].setValue(config.dunningCycleAction);
          this.fillDunningCycle(config.dunningCycle);
        } else {
          this.dunningCycle.push(this.setDunningCycle());
        }

        this.isFormReady = true;
      },
      (err: RestResponse) => {
        this.isFormReady = true;
        this._meta.showNotification(err);
      }
    );
  }

  newNotificationEmail(_index?, notificationEmail?) {
    if (notificationEmail) {
      this.dunningCycle.push(this.setDunningCycle(notificationEmail.cycleFrec));
      if (_index === 0) {
        this.collectionOfCounters[_index] = this.utils.convertToNumber(notificationEmail.cycleFrec);
      } else {
        this.collectionOfCounters[_index] = this.utils.convertToNumber(notificationEmail.cycleFrec) + this.collectionOfCounters[_index -1 ];
      }
    } else {
      this.dunningCycle.push(this.setDunningCycle());
    }
  }

  ngOnInit() {
    this.setUpForm();
    this.getDunningConfig();
    this.onChanges();
  }

  onChanges(): void {
    this.form.get('dunningCycle').valueChanges.subscribe(dunningCycleArray => {
      for (let i = 0; i < dunningCycleArray.length; i++) {
        if (i === 0) {
          this.collectionOfCounters[i] = this.utils.convertToNumber(dunningCycleArray[i].cycleFrec);
        } else {
          this.collectionOfCounters[i] = this.utils.convertToNumber(dunningCycleArray[i].cycleFrec) + this.collectionOfCounters[i-1];
        }
      }
    });
  }

  onChangeRatePlanOptions(_value: string) {
    this.form.get('dunningCycleAction').setValue(_value);
  }

  onChangeEmailTemplate(_index, _value: string) {
    this.form.get('dunningCycle').get(_index).get('emailType').setValue(_value);
  }

  updateDunningConfiguration(bodyParams: any) {
    this.subs.addSub = this.settingsService.updateDunningConfiguration(bodyParams).subscribe(
      (res: RestResponse) => {
        this.formSubmitted = !this.formSubmitted;
        this._meta.showNotification(res);
        this._router.navigate(['main/settings/advanced/dunning-management']);
      },
      (err: RestResponse) => {
        this.formSubmitted = !this.formSubmitted;
        this._meta.showNotification(err);
      });
  }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;

    if (this.form.invalid) {
      this.formSubmitted = !this.formSubmitted;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }

    if(this.form.value?.dunningCycle) {
      this.form.value?.dunningCycle.forEach(element => {
        element.cycleFrec = String(element.cycleFrec),
        element.cycleUnit = element.cycleUnit
      });
    }

    let bodyParams = { dunningConfigAuto: this.form.value };
    this.updateDunningConfiguration(bodyParams);
  }

  removeNotificationEmail(_index) {
    this.collectionOfCounters.splice(_index, 1);
    this.dunningCycle.removeAt(_index);
  }

  setDunningCycle(cycleFrec?): FormGroup {
    return this._fb.group({
      cycleFrec: new FormControl(cycleFrec ? String(cycleFrec) : '1'),
      cycleUnit: new FormControl('d'),
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
